var items = {
  "block.minecraft.air": "áibmu",
  "block.minecraft.stone": "geađgi",
  "block.minecraft.granite": "granihtta",
  "block.minecraft.polished_granite": "bussejuvvon granihtta",
  "block.minecraft.diorite": "diorihtta",
  "block.minecraft.polished_diorite": "bussejuvvon diorihtta",
  "block.minecraft.andesite": "ándasihtta",
  "block.minecraft.polished_andesite": "bussejuvvon ándasihtta",
  "block.minecraft.grass_block": "suoidneblohkka",
  "block.minecraft.dirt": "eana",
  "block.minecraft.coarse_dirt": "roattoseana",
  "block.minecraft.podzol": "podsola",
  "block.minecraft.crimson_nylium": "skárllatmirkoeana",
  "block.minecraft.warped_nylium": "skuibesmirkoeana",
  "block.minecraft.cobblestone": "luoddageađgi",
  "block.minecraft.oak_planks": "eaikafiellut",
  "block.minecraft.spruce_planks": "guossafiellut",
  "block.minecraft.birch_planks": "soahkefiellut",
  "block.minecraft.jungle_planks": "suhkkesvuovdefiellut",
  "block.minecraft.acacia_planks": "acaciafiellut",
  "block.minecraft.dark_oak_planks": "sevdnjes eaikafiellut",
  "block.minecraft.crimson_planks": "skárllatfiellut",
  "block.minecraft.warped_planks": "bonjofiellut",
  "block.minecraft.oak_sapling": "eaikamuoraš",
  "block.minecraft.spruce_sapling": "guossamuoraš",
  "block.minecraft.birch_sapling": "soahkemuoraš",
  "block.minecraft.jungle_sapling": "suhkkesvuovdemuoraš",
  "block.minecraft.acacia_sapling": "acaciamuoraš",
  "block.minecraft.dark_oak_sapling": "sevdnjes eaikamuoraš",
  "block.minecraft.bedrock": "báktevuođđu",
  "block.minecraft.sand": "sáttu",
  "block.minecraft.red_sand": "ruksessáttu",
  "block.minecraft.gravel": "čievra",
  "block.minecraft.gold_ore": "gollemálbma",
  "block.minecraft.iron_ore": "ruovdemálbma",
  "block.minecraft.coal_ore": "koallamálbma",
  "block.minecraft.nether_gold_ore": "nether gollemálbma",
  "block.minecraft.oak_log": "eaikabelko",
  "block.minecraft.spruce_log": "guossabelko",
  "block.minecraft.birch_log": "soahkebelko",
  "block.minecraft.jungle_log": "suhkkesvuovdebelko",
  "block.minecraft.acacia_log": "acaciabelko",
  "block.minecraft.dark_oak_log": "sevdnjes eaikabelko",
  "block.minecraft.crimson_stem": "skárllatmátta",
  "block.minecraft.warped_stem": "bonjonađđa",
  "block.minecraft.stripped_oak_log": "vullojuvvon eaikabelko",
  "block.minecraft.stripped_spruce_log": "vullojuvvon guossabelko",
  "block.minecraft.stripped_birch_log": "vullojuvvon soahkebelko",
  "block.minecraft.stripped_jungle_log": "vullojuvvon suhkkesvuovdebelko",
  "block.minecraft.stripped_acacia_log": "vullojuvvon acaciabelko",
  "block.minecraft.stripped_dark_oak_log": "vullojuvvon sevdnjes eaikabelko",
  "block.minecraft.stripped_crimson_stem": "vullojuvvon skárllatađđa",
  "block.minecraft.stripped_warped_stem": "vullojuvvon bonjonađđa",
  "block.minecraft.stripped_oak_wood": "vullojuvvon eaikamuorra",
  "block.minecraft.stripped_spruce_wood": "vullojuvvon guossamuorra",
  "block.minecraft.stripped_birch_wood": "vullojuvvon soahkemuorra",
  "block.minecraft.stripped_jungle_wood": "vullojuvvon suhkkesvuovdemuorra",
  "block.minecraft.stripped_acacia_wood": "vullojuvvon acaciamuorra",
  "block.minecraft.stripped_dark_oak_wood": "vullojuvvon sevdnjes eaikamuorra",
  "block.minecraft.stripped_crimson_hyphae": "vullojuvvon skárllatsuorus",
  "block.minecraft.stripped_warped_hyphae": "vullojuvvon bonjosuorus",
  "block.minecraft.oak_wood": "eaikamuorra",
  "block.minecraft.spruce_wood": "guossamuorra",
  "block.minecraft.birch_wood": "soahkemuorra",
  "block.minecraft.jungle_wood": "suhkkesvuovdemuorra",
  "block.minecraft.acacia_wood": "acaciamuorra",
  "block.minecraft.dark_oak_wood": "sevdnjes eaikamuorra",
  "block.minecraft.crimson_hyphae": "skárllatsuorus",
  "block.minecraft.warped_hyphae": "bonjosuorus",
  "block.minecraft.oak_leaves": "eaikalasttat",
  "block.minecraft.spruce_leaves": "guossalasttat",
  "block.minecraft.birch_leaves": "soahkelasttat",
  "block.minecraft.jungle_leaves": "suhkkesvuovdelasttat",
  "block.minecraft.acacia_leaves": "acacialasttat",
  "block.minecraft.dark_oak_leaves": "sevdnjes eaikalasttat",
  "block.minecraft.sponge": "guopparas",
  "block.minecraft.wet_sponge": "njuoska guopparas",
  "block.minecraft.glass": "glássa",
  "block.minecraft.lapis_ore": "lasuramálbma",
  "block.minecraft.lapis_block": "lasurablohkka",
  "block.minecraft.dispenser": "bážán",
  "block.minecraft.sandstone": "sáttogeađgi",
  "block.minecraft.chiseled_sandstone": "lukčon sáttogeađgi",
  "block.minecraft.cut_sandstone": "njulgejuvvon sáttogeađgi",
  "block.minecraft.note_block": "nuohttablohkka",
  "block.minecraft.powered_rail": "rávdnjás ruovdemáđđi",
  "block.minecraft.detector_rail": "iskkan ruovdemáđđi",
  "block.minecraft.sticky_piston": "njivllas hoigi",
  "block.minecraft.cobweb": "heavdnefierbmi",
  "block.minecraft.grass": "suoidni",
  "block.minecraft.fern": "gáiski",
  "block.minecraft.dead_bush": "goikemiestta",
  "block.minecraft.seagrass": "debbot",
  "block.minecraft.sea_pickle": "mearrašaddu",
  "block.minecraft.piston": "hoigi",
  "block.minecraft.white_wool": "vilges ullu",
  "block.minecraft.orange_wool": "runta ullu",
  "block.minecraft.magenta_wool": "čuvgessáhppes ullu",
  "block.minecraft.light_blue_wool": "čuvgesalit ullu",
  "block.minecraft.yellow_wool": "fiskes ullu",
  "block.minecraft.lime_wool": "čuvgesruoná ullu",
  "block.minecraft.pink_wool": "čuvgesruokses ullu",
  "block.minecraft.gray_wool": "ránes ullu",
  "block.minecraft.light_gray_wool": "čuvgesránes ullu",
  "block.minecraft.cyan_wool": "turkiisa ullu",
  "block.minecraft.purple_wool": "sáhppes ullu",
  "block.minecraft.blue_wool": "alit ullu",
  "block.minecraft.brown_wool": "ruškes ullu",
  "block.minecraft.green_wool": "ruoná ullu",
  "block.minecraft.red_wool": "rukses ullu",
  "block.minecraft.black_wool": "čáhppes ullu",
  "block.minecraft.dandelion": "uvlorássi",
  "block.minecraft.poppy": "ajerássi",
  "block.minecraft.blue_orchid": "alit orkidéa",
  "block.minecraft.allium": "ruksesluovvar",
  "block.minecraft.azure_bluet": "nuorsá",
  "block.minecraft.red_tulip": "rukses tulipána",
  "block.minecraft.orange_tulip": "runta tulipána",
  "block.minecraft.white_tulip": "vilges tulipána",
  "block.minecraft.pink_tulip": "čuvgesrukses tulipána",
  "block.minecraft.oxeye_daisy": "báhpačehporas",
  "block.minecraft.cornflower": "rohkarássi",
  "block.minecraft.lily_of_the_valley": "ávželieđđi",
  "block.minecraft.wither_rose": "witherlieđđi",
  "block.minecraft.brown_mushroom": "ruškes guoppar",
  "block.minecraft.red_mushroom": "rukses guoppar",
  "block.minecraft.crimson_fungus": "skárllatguoppar",
  "block.minecraft.warped_fungus": "bonjoguoppar",
  "block.minecraft.crimson_roots": "skárllatruohtas",
  "block.minecraft.warped_roots": "bonjoruohtas",
  "block.minecraft.nether_sprouts": "netherrahttá",
  "block.minecraft.weeping_vines": "ganjaldan goargŋunšaddu",
  "block.minecraft.twisting_vines": "gierrinan goargŋunšaddu",
  "block.minecraft.sugar_cane": "sohkargoalšu",
  "block.minecraft.kelp": "stárra",
  "block.minecraft.bamboo": "bamboa",
  "block.minecraft.gold_block": "golleblohkka",
  "block.minecraft.iron_block": "ruovdeblohkka",
  "block.minecraft.oak_slab": "eaikapláhtta",
  "block.minecraft.spruce_slab": "guossapláhtta",
  "block.minecraft.birch_slab": "soahkepláhtta",
  "block.minecraft.jungle_slab": "suhkkesvuovdepláhtta",
  "block.minecraft.acacia_slab": "acaciapláhtta",
  "block.minecraft.dark_oak_slab": "sevdnjes eaikapláhtta",
  "block.minecraft.crimson_slab": "skárllatbealli",
  "block.minecraft.warped_slab": "bonjopláhtta",
  "block.minecraft.stone_slab": "geađgepláhtta",
  "block.minecraft.smooth_stone_slab": "livttis geađgepláhtta",
  "block.minecraft.sandstone_slab": "sáttogeađgepláhtta",
  "block.minecraft.cut_sandstone_slab": "čuhppon sáttogeađgepláhtta",
  "block.minecraft.petrified_oak_slab": "geađgás eaikapláhtta",
  "block.minecraft.cobblestone_slab": "luoddageađgepláhtta",
  "block.minecraft.brick_slab": "muvrapláhtta",
  "block.minecraft.stone_brick_slab": "geađgemuvrapláhtta",
  "block.minecraft.nether_brick_slab": "nethermuvrabealli",
  "block.minecraft.quartz_slab": "kvárcapláhtta",
  "block.minecraft.red_sandstone_slab": "rukses sáttogeađgepláhtta",
  "block.minecraft.cut_red_sandstone_slab": "čuhppon rukses sáttogeađgepláhtta",
  "block.minecraft.purpur_slab": "purpurpláhtta",
  "block.minecraft.prismarine_slab": "prismariidnapláhtta",
  "block.minecraft.prismarine_brick_slab": "prismariidnamuvrapláhtta",
  "block.minecraft.dark_prismarine_slab": "sevdnjes prismariidnapláhtta",
  "block.minecraft.smooth_quartz": "livttis kvárcablohkka",
  "block.minecraft.smooth_red_sandstone": "livttis rukses sáttogeađgi",
  "block.minecraft.smooth_sandstone": "livttis sáttogeađgi",
  "block.minecraft.smooth_stone": "livttis geađgi",
  "block.minecraft.bricks": "muvra",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "girjehildu",
  "block.minecraft.mossy_cobblestone": "jeagilduvvan luoddageađgi",
  "block.minecraft.obsidian": "obsidiána",
  "block.minecraft.torch": "spáiddar",
  "block.minecraft.end_rod": "endorsággi",
  "block.minecraft.chorus_plant": "chorusšaddu",
  "block.minecraft.chorus_flower": "choruslieđđi",
  "block.minecraft.purpur_block": "purpurblohkka",
  "block.minecraft.purpur_pillar": "purpurstoalpu",
  "block.minecraft.purpur_stairs": "purpurtráhppá",
  "block.minecraft.spawner": "stálloealáskahtti",
  "block.minecraft.oak_stairs": "eaikatráhppá",
  "block.minecraft.chest": "bumbá",
  "block.minecraft.diamond_ore": "diamántamálbma",
  "block.minecraft.diamond_block": "diamántablohkka",
  "block.minecraft.crafting_table": "duodjebeavdi",
  "block.minecraft.farmland": "gilvineana",
  "block.minecraft.furnace": "uvdna",
  "block.minecraft.ladder": "ráidalas",
  "block.minecraft.rail": "ruovdemáđđi",
  "block.minecraft.cobblestone_stairs": "luoddageađgetráhppá",
  "block.minecraft.lever": "geavja",
  "block.minecraft.stone_pressure_plate": "geađgedeattopláhtta",
  "block.minecraft.oak_pressure_plate": "eaikadeattopláhtta",
  "block.minecraft.spruce_pressure_plate": "guossadeattopláhtta",
  "block.minecraft.birch_pressure_plate": "soahkedeattopláhtta",
  "block.minecraft.jungle_pressure_plate": "suhkkesvuovdedeattopláhtta",
  "block.minecraft.acacia_pressure_plate": "acaciadeattopláhtta",
  "block.minecraft.dark_oak_pressure_plate": "sevdnjes eaikadeattopláhtta",
  "block.minecraft.crimson_pressure_plate": "skárllatdeattopláhtta",
  "block.minecraft.warped_pressure_plate": "bonjodeattopláhtta",
  "block.minecraft.polished_blackstone_pressure_plate": "bussejuvvon čáhppesgeađgedeattopláhtta",
  "block.minecraft.redstone_ore": "redstonemálbma",
  "block.minecraft.redstone_torch": "redstonespáiddar",
  "block.minecraft.snow": "muohta",
  "block.minecraft.ice": "jiekŋa",
  "block.minecraft.snow_block": "muohtablohkka",
  "block.minecraft.cactus": "káktus",
  "block.minecraft.clay": "láira",
  "block.minecraft.jukebox": "skearročuojanas",
  "block.minecraft.oak_fence": "eaikaáidi",
  "block.minecraft.spruce_fence": "guossaáidi",
  "block.minecraft.birch_fence": "soahkeáidi",
  "block.minecraft.jungle_fence": "suhkkesvuovdeáidi",
  "block.minecraft.acacia_fence": "acaciaáidi",
  "block.minecraft.dark_oak_fence": "sevdnjes eaikaáidi",
  "block.minecraft.crimson_fence": "skárllatáidi",
  "block.minecraft.warped_fence": "bonjoáidi",
  "block.minecraft.pumpkin": "gurbbet",
  "block.minecraft.carved_pumpkin": "čuhppon gurbbet",
  "block.minecraft.netherrack": "nethergeađgi",
  "block.minecraft.soul_sand": "siellosáttu",
  "block.minecraft.soul_soil": "sielloeana",
  "block.minecraft.basalt": "basaltta",
  "block.minecraft.polished_basalt": "bussejuvvon basaltta",
  "block.minecraft.soul_torch": "siellospáiddar",
  "block.minecraft.glowstone": "čuovgageađgi",
  "block.minecraft.jack_o_lantern": "gurbbetčuovga",
  "block.minecraft.oak_trapdoor": "eaikaluŋká",
  "block.minecraft.spruce_trapdoor": "guossaluŋká",
  "block.minecraft.birch_trapdoor": "soahkeluŋká",
  "block.minecraft.jungle_trapdoor": "suhkkesvuovdeluŋká",
  "block.minecraft.acacia_trapdoor": "acacialuŋká",
  "block.minecraft.dark_oak_trapdoor": "sevdnjes eaikaluŋká",
  "block.minecraft.crimson_trapdoor": "skárllatluŋká",
  "block.minecraft.warped_trapdoor": "bonjoluŋká",
  "block.minecraft.infested_stone": "njommon geađgi",
  "block.minecraft.infested_cobblestone": "njommon luoddageađgi",
  "block.minecraft.infested_stone_bricks": "njommon geađgemuvra",
  "block.minecraft.infested_mossy_stone_bricks": "njommon jeagilduvvan geađgemuvra",
  "block.minecraft.infested_cracked_stone_bricks": "njommon luoddanan geađgemuvra",
  "block.minecraft.infested_chiseled_stone_bricks": "njommon lukčon geađgemuvra",
  "block.minecraft.stone_bricks": "geađgemuvra",
  "block.minecraft.mossy_stone_bricks": "jeagilduvvan geađgemuvra",
  "block.minecraft.cracked_stone_bricks": "luoddanan geađgemuvra",
  "block.minecraft.chiseled_stone_bricks": "lukčon geađgemuvra",
  "block.minecraft.brown_mushroom_block": "ruškes guopparblohkka",
  "block.minecraft.red_mushroom_block": "rukses guopparblohkka",
  "block.minecraft.mushroom_stem": "guoppamáddu",
  "block.minecraft.iron_bars": "ruovdegiddagas",
  "block.minecraft.chain": "viđji",
  "block.minecraft.glass_pane": "glássaruvtto",
  "block.minecraft.melon": "melovdna",
  "block.minecraft.vine": "goargŋunsuoidni",
  "block.minecraft.oak_fence_gate": "eaikaverrát",
  "block.minecraft.spruce_fence_gate": "guossaverrát",
  "block.minecraft.birch_fence_gate": "soahkeverrát",
  "block.minecraft.jungle_fence_gate": "suhkkesvuovdeverrát",
  "block.minecraft.acacia_fence_gate": "acaciaverrát",
  "block.minecraft.dark_oak_fence_gate": "sevdnjes eaikaverrát",
  "block.minecraft.crimson_fence_gate": "skárllatverrát",
  "block.minecraft.warped_fence_gate": "bonjoverrát",
  "block.minecraft.brick_stairs": "muvratráhppá",
  "block.minecraft.stone_brick_stairs": "geađgemuvratráhppá",
  "block.minecraft.mycelium": "mirkoeana",
  "block.minecraft.lily_pad": "govdodanlieđđi",
  "block.minecraft.nether_bricks": "nethermuvra",
  "block.minecraft.cracked_nether_bricks": "luoddanan nethergeađgemuvra",
  "block.minecraft.chiseled_nether_bricks": "lukčon nethergeađgemuvra",
  "block.minecraft.nether_brick_fence": "nethermuvraáidi",
  "block.minecraft.nether_brick_stairs": "nethermuvratráhppá",
  "block.minecraft.enchanting_table": "noaidunbeavdi",
  "block.minecraft.end_portal_frame": "endorportálarámma",
  "block.minecraft.end_stone": "endorgeađgi",
  "block.minecraft.end_stone_bricks": "endorgeađgemuvra",
  "block.minecraft.dragon_egg": "drágemonni",
  "block.minecraft.redstone_lamp": "redstonečuovga",
  "block.minecraft.sandstone_stairs": "sáttogeađgetráhppá",
  "block.minecraft.emerald_ore": "emeraldamálbma",
  "block.minecraft.ender_chest": "endorbumbá",
  "block.minecraft.tripwire_hook": "guossanbátti sággi",
  "block.minecraft.emerald_block": "emeraldablohkka",
  "block.minecraft.spruce_stairs": "guossatráhppá",
  "block.minecraft.birch_stairs": "soahketráhppá",
  "block.minecraft.jungle_stairs": "suhkkesvuovdetráhppá",
  "block.minecraft.crimson_stairs": "skárllattráhppát",
  "block.minecraft.warped_stairs": "bonjotráhppát",
  "block.minecraft.command_block": "kommándoblohkka",
  "block.minecraft.beacon": "várdočuovga",
  "block.minecraft.cobblestone_wall": "luoddageađgge seaidni",
  "block.minecraft.mossy_cobblestone_wall": "jeagilduvvan luoddageađgeseaidni",
  "block.minecraft.brick_wall": "muvraseaidni",
  "block.minecraft.prismarine_wall": "prismariidnaseaidni",
  "block.minecraft.red_sandstone_wall": "ruksessáttogeađge seaidni",
  "block.minecraft.mossy_stone_brick_wall": "jeagilduvvan geađgemuvraseaidni",
  "block.minecraft.granite_wall": "granihtta seaidni",
  "block.minecraft.stone_brick_wall": "geađgemuvra seaidni",
  "block.minecraft.nether_brick_wall": "nethermuvra seaidni",
  "block.minecraft.andesite_wall": "ándasihtta seaidni",
  "block.minecraft.red_nether_brick_wall": "rukses nethermuvra seaidni",
  "block.minecraft.sandstone_wall": "sáttogeađge seaidni",
  "block.minecraft.end_stone_brick_wall": "endor geađgemuvra seaidni",
  "block.minecraft.diorite_wall": "diorihtta seaidni",
  "block.minecraft.blackstone_wall": "čáhppesgeađge seaidni",
  "block.minecraft.polished_blackstone_wall": "bussejuvvon čáhppesgeađge seaidni",
  "block.minecraft.polished_blackstone_brick_wall": "bussejuvvon čáhppesgeađgemuvraseaidni",
  "block.minecraft.stone_button": "geađgeboallu",
  "block.minecraft.oak_button": "eaikaboallu",
  "block.minecraft.spruce_button": "guossaboallu",
  "block.minecraft.birch_button": "soahkeboallu",
  "block.minecraft.jungle_button": "suhkkesvuovdeboallu",
  "block.minecraft.acacia_button": "acaciaboallu",
  "block.minecraft.dark_oak_button": "sevdnjes eaikaboallu",
  "block.minecraft.crimson_button": "skárllatboallu",
  "block.minecraft.warped_button": "bonjoboallu",
  "block.minecraft.polished_blackstone_button": "bussejuvvon čáhppesgeađgeboallu",
  "block.minecraft.anvil": "stáđđi",
  "block.minecraft.chipped_anvil": "reakčanan stáđđi",
  "block.minecraft.damaged_anvil": "billašuvvan stáđđi",
  "block.minecraft.trapped_chest": "darvvihahttinbumbá",
  "block.minecraft.light_weighted_pressure_plate": "geahpadeattupláhtta",
  "block.minecraft.heavy_weighted_pressure_plate": "lossadeattupláhtta",
  "block.minecraft.daylight_detector": "beaivečuovgga iski",
  "block.minecraft.redstone_block": "redstoneblohkka",
  "block.minecraft.nether_quartz_ore": "netherkvárcamálbma",
  "block.minecraft.hopper": "njammi",
  "block.minecraft.chiseled_quartz_block": "lukčon kvárcablohkka",
  "block.minecraft.quartz_block": "kvárcablohkka",
  "block.minecraft.quartz_bricks": "kvarcamuvra",
  "block.minecraft.quartz_pillar": "kvárcastoalpu",
  "block.minecraft.quartz_stairs": "kvárcatráhppá",
  "block.minecraft.activator_rail": "álggahahttin ruovdemáđđi",
  "block.minecraft.dropper": "luoiti",
  "block.minecraft.white_terracotta": "vilges terrakotta",
  "block.minecraft.orange_terracotta": "runta terrakotta",
  "block.minecraft.magenta_terracotta": "čuvgessáhppes terrakotta",
  "block.minecraft.light_blue_terracotta": "čuvgesalit terrakotta",
  "block.minecraft.yellow_terracotta": "fiskes terrakotta",
  "block.minecraft.lime_terracotta": "čuvgesruoná terrakotta",
  "block.minecraft.pink_terracotta": "rosa terrakotta",
  "block.minecraft.gray_terracotta": "ránes terrakotta",
  "block.minecraft.light_gray_terracotta": "čuvgesránes terrakotta",
  "block.minecraft.cyan_terracotta": "turkiisa terrakotta",
  "block.minecraft.purple_terracotta": "sáhppes terrakotta",
  "block.minecraft.blue_terracotta": "alit terrakotta",
  "block.minecraft.brown_terracotta": "ruškes terrakotta",
  "block.minecraft.green_terracotta": "ruoná terrakotta",
  "block.minecraft.red_terracotta": "rukses terrakotta",
  "block.minecraft.black_terracotta": "čáhppes terrakotta",
  "block.minecraft.barrier": "caggi",
  "block.minecraft.iron_trapdoor": "ruovdeluŋká",
  "block.minecraft.hay_block": "suoidnegubá",
  "block.minecraft.white_carpet": "vilges láhtterátnu",
  "block.minecraft.orange_carpet": "runta láhtterátnu",
  "block.minecraft.magenta_carpet": "čuvgessáhppes láhtterátnu",
  "block.minecraft.light_blue_carpet": "čuvgesalit láhtterátnu",
  "block.minecraft.yellow_carpet": "fiskes láhtterátnu",
  "block.minecraft.lime_carpet": "lime láhtterátnu",
  "block.minecraft.pink_carpet": "vilgesruokses láhtterátnu",
  "block.minecraft.gray_carpet": "ránes láhtterátnu",
  "block.minecraft.light_gray_carpet": "čuvgesránes láhtterátnu",
  "block.minecraft.cyan_carpet": "turkiisa láhtterátnu",
  "block.minecraft.purple_carpet": "sáhppes láhtterátnu",
  "block.minecraft.blue_carpet": "alit láhtterátnu",
  "block.minecraft.brown_carpet": "ruškes láhtterátnu",
  "block.minecraft.green_carpet": "ruoná láhtterátnu",
  "block.minecraft.red_carpet": "rukses láhtterátnu",
  "block.minecraft.black_carpet": "čáhppes láhtterátnu",
  "block.minecraft.terracotta": "terrakotta",
  "block.minecraft.coal_block": "koallablohkka",
  "block.minecraft.packed_ice": "garrajiekŋa",
  "block.minecraft.acacia_stairs": "acaciatráhppá",
  "block.minecraft.dark_oak_stairs": "sevdnjes eaikatráhppá",
  "block.minecraft.slime_block": "njivleblohkka",
  "block.minecraft.grass_path": "bálggis",
  "block.minecraft.sunflower": "beaivvášlieđđi",
  "block.minecraft.lilac": "siriidna",
  "block.minecraft.rose_bush": "rosamiestta",
  "block.minecraft.peony": "piovdna",
  "block.minecraft.tall_grass": "alla suoidni",
  "block.minecraft.large_fern": "stuora gáiski",
  "block.minecraft.white_stained_glass": "vilges glássa",
  "block.minecraft.orange_stained_glass": "runta glássa",
  "block.minecraft.magenta_stained_glass": "magenta glássa",
  "block.minecraft.light_blue_stained_glass": "čuvgesalit glássa",
  "block.minecraft.yellow_stained_glass": "fiskes glássa",
  "block.minecraft.lime_stained_glass": "čuvgesruoná glássa",
  "block.minecraft.pink_stained_glass": "čuvgesruoksat glássa",
  "block.minecraft.gray_stained_glass": "ránes glássa",
  "block.minecraft.light_gray_stained_glass": "čuvgesránes glássa",
  "block.minecraft.cyan_stained_glass": "turkiisa glássa",
  "block.minecraft.purple_stained_glass": "sáhppes glássa",
  "block.minecraft.blue_stained_glass": "alit glássa",
  "block.minecraft.brown_stained_glass": "ruškes glássa",
  "block.minecraft.green_stained_glass": "ruoná glássa",
  "block.minecraft.red_stained_glass": "rukses glássa",
  "block.minecraft.black_stained_glass": "čáhppes glássa",
  "block.minecraft.white_stained_glass_pane": "vilges glássaruvtto",
  "block.minecraft.orange_stained_glass_pane": "runta glássaruvtto",
  "block.minecraft.magenta_stained_glass_pane": "magenta glássaruvtto",
  "block.minecraft.light_blue_stained_glass_pane": "čuvgesalit glássaruvtto",
  "block.minecraft.yellow_stained_glass_pane": "fiskes glássaruvtto",
  "block.minecraft.lime_stained_glass_pane": "čuvgesruoná glássaruvtto",
  "block.minecraft.pink_stained_glass_pane": "čuvgesrukses glássaruvtto",
  "block.minecraft.gray_stained_glass_pane": "ránes glássaruvtto",
  "block.minecraft.light_gray_stained_glass_pane": "čuvgesránes glássaruvtto",
  "block.minecraft.cyan_stained_glass_pane": "turkiisa glássaruvtto",
  "block.minecraft.purple_stained_glass_pane": "sáhppes glássaruvtto",
  "block.minecraft.blue_stained_glass_pane": "alit glássaruvtto",
  "block.minecraft.brown_stained_glass_pane": "ruškes glássaruvtto",
  "block.minecraft.green_stained_glass_pane": "ruoná glássaruvtto",
  "block.minecraft.red_stained_glass_pane": "rukses glássaruvtto",
  "block.minecraft.black_stained_glass_pane": "čáhppes glássaruvtto",
  "block.minecraft.prismarine": "prismariidna",
  "block.minecraft.prismarine_bricks": "prismariidnamuvra",
  "block.minecraft.dark_prismarine": "sevdnjes prismariidna",
  "block.minecraft.prismarine_stairs": "prismariidnatráhppá",
  "block.minecraft.prismarine_brick_stairs": "prismariidnamuvratráhppá",
  "block.minecraft.dark_prismarine_stairs": "sevdnjes prismariidnatráhppá",
  "block.minecraft.sea_lantern": "mearračuovga",
  "block.minecraft.red_sandstone": "﻿rukses sáttogeađgi",
  "block.minecraft.chiseled_red_sandstone": "lukčon rukses sáttogeađgi",
  "block.minecraft.cut_red_sandstone": "njuolgejuvvon rukses sáttogeađgi",
  "block.minecraft.red_sandstone_stairs": "rukses sáttogeađgetráhppá",
  "block.minecraft.repeating_command_block": "geardduhan kommándoblohkka",
  "block.minecraft.chain_command_block": "ráido kommándoblohkka",
  "block.minecraft.magma_block": "magmablohkka",
  "block.minecraft.nether_wart_block": "nether spártoblohkka",
  "block.minecraft.warped_wart_block": "bonjospártoblohkka",
  "block.minecraft.red_nether_bricks": "rukses nethermuvra",
  "block.minecraft.bone_block": "dákteblohkka",
  "block.minecraft.structure_void": "huskehus gomuvuohta",
  "block.minecraft.observer": "áici",
  "block.minecraft.shulker_box": "shulkerboksa",
  "block.minecraft.white_shulker_box": "vilges shulkerboksa",
  "block.minecraft.orange_shulker_box": "runta shulkerboksa",
  "block.minecraft.magenta_shulker_box": "čuvgessáhppes shulkerboksa",
  "block.minecraft.light_blue_shulker_box": "čuvgesalit shulkerboksa",
  "block.minecraft.yellow_shulker_box": "fiskes shulkerboksa",
  "block.minecraft.lime_shulker_box": "čuvgesruoná shulkerboksa",
  "block.minecraft.pink_shulker_box": "čuvgesrukses shulkerboksa",
  "block.minecraft.gray_shulker_box": "ránes shulkerboksa",
  "block.minecraft.light_gray_shulker_box": "čuvgesránes shulkerboksa",
  "block.minecraft.cyan_shulker_box": "turkiisa shulkerboksa",
  "block.minecraft.purple_shulker_box": "sáhppes shulkerboksa",
  "block.minecraft.blue_shulker_box": "alit shulkerboksa",
  "block.minecraft.brown_shulker_box": "ruškes shulkerboksa",
  "block.minecraft.green_shulker_box": "ruoná shulkerboksa",
  "block.minecraft.red_shulker_box": "rukses shulkerboksa",
  "block.minecraft.black_shulker_box": "čáhppes shulkerboksa",
  "block.minecraft.white_glazed_terracotta": "vilges šelges terrakotta",
  "block.minecraft.orange_glazed_terracotta": "runta šelges terrakotta",
  "block.minecraft.magenta_glazed_terracotta": "čuvgessáhppes šelges terrakotta",
  "block.minecraft.light_blue_glazed_terracotta": "čuvgesalit šelges terrakotta",
  "block.minecraft.yellow_glazed_terracotta": "fiskes šelges terrakotta",
  "block.minecraft.lime_glazed_terracotta": "čuvgesruoná šelges terrakotta",
  "block.minecraft.pink_glazed_terracotta": "vilgesrukses šelges terrakotta",
  "block.minecraft.gray_glazed_terracotta": "ránes šelges terrakotta",
  "block.minecraft.light_gray_glazed_terracotta": "čuvgesránes šelges terrakotta",
  "block.minecraft.cyan_glazed_terracotta": "turkiisa šelges terrakotta",
  "block.minecraft.purple_glazed_terracotta": "sáhppes šelges terrakotta",
  "block.minecraft.blue_glazed_terracotta": "alit šelges terrakotta",
  "block.minecraft.brown_glazed_terracotta": "ruškes šelges terrakotta",
  "block.minecraft.green_glazed_terracotta": "ruoná šelges terrakotta",
  "block.minecraft.red_glazed_terracotta": "rukses šelges terrakotta",
  "block.minecraft.black_glazed_terracotta": "čáhppes šelges terrakotta",
  "block.minecraft.white_concrete": "vilges betoŋŋa",
  "block.minecraft.orange_concrete": "runta betoŋŋa",
  "block.minecraft.magenta_concrete": "čuvgessáhppes betoŋŋa",
  "block.minecraft.light_blue_concrete": "čuvgesalit betoŋŋa",
  "block.minecraft.yellow_concrete": "fiskes betoŋŋa",
  "block.minecraft.lime_concrete": "čuvgesruoná betoŋŋa",
  "block.minecraft.pink_concrete": "čuvgesrukses betoŋŋa",
  "block.minecraft.gray_concrete": "ránes betoŋŋa",
  "block.minecraft.light_gray_concrete": "čuvgesránes betoŋŋa",
  "block.minecraft.cyan_concrete": "turkiisa betoŋŋa",
  "block.minecraft.purple_concrete": "sáhppes betoŋŋa",
  "block.minecraft.blue_concrete": "alit betoŋŋa",
  "block.minecraft.brown_concrete": "ruškes betoŋŋa",
  "block.minecraft.green_concrete": "ruoná betoŋŋa",
  "block.minecraft.red_concrete": "rukses betoŋŋa",
  "block.minecraft.black_concrete": "čáhppes betoŋŋa",
  "block.minecraft.white_concrete_powder": "vilges betoŋŋabulvvar",
  "block.minecraft.orange_concrete_powder": "runta betoŋŋabulvvar",
  "block.minecraft.magenta_concrete_powder": "čuvgessáhppes betoŋŋabulvvar",
  "block.minecraft.light_blue_concrete_powder": "čuvgesalit betoŋŋabulvvar",
  "block.minecraft.yellow_concrete_powder": "fiskes betoŋŋabulvvar",
  "block.minecraft.lime_concrete_powder": "čuvgesruonaá betoŋŋabulvvar",
  "block.minecraft.pink_concrete_powder": "čuvgesrukses betoŋŋabulvvar",
  "block.minecraft.gray_concrete_powder": "ránes betoŋŋabulvvar",
  "block.minecraft.light_gray_concrete_powder": "čuvgesránes betoŋŋabulvvar",
  "block.minecraft.cyan_concrete_powder": "turkiisa betoŋŋabulvvar",
  "block.minecraft.purple_concrete_powder": "sáhppes betoŋŋabulvvar",
  "block.minecraft.blue_concrete_powder": "alit betoŋŋabulvvar",
  "block.minecraft.brown_concrete_powder": "ruškes betoŋŋabulvvar",
  "block.minecraft.green_concrete_powder": "ruoná betoŋŋabulvvar",
  "block.minecraft.red_concrete_powder": "rukses betoŋŋabulvvar",
  "block.minecraft.black_concrete_powder": "čáhppes betoŋŋabulvvar",
  "block.minecraft.turtle_egg": "galbarihccemonni",
  "block.minecraft.dead_tube_coral_block": "jápman bohcci korallablohkka",
  "block.minecraft.dead_brain_coral_block": "jápman vuoŋŋamuš korallablohkka",
  "block.minecraft.dead_bubble_coral_block": "jápman bulljaras korallablohkka",
  "block.minecraft.dead_fire_coral_block": "jápman dolla korallablohkka",
  "block.minecraft.dead_horn_coral_block": "jápman čoarvvás korallablohkka",
  "block.minecraft.tube_coral_block": "bohcci korallablohkka",
  "block.minecraft.brain_coral_block": "vuoŋŋamuš korallablohkka",
  "block.minecraft.bubble_coral_block": "bulljaras korallablohkka",
  "block.minecraft.fire_coral_block": "dolla korallablohkka",
  "block.minecraft.horn_coral_block": "čoarvvás korallablohkka",
  "block.minecraft.tube_coral": "bohcci koralla",
  "block.minecraft.brain_coral": "vuiŋŋamuš korálla",
  "block.minecraft.bubble_coral": "buillaras korálla",
  "block.minecraft.fire_coral": "dolla korálla",
  "block.minecraft.horn_coral": "čoarve korálla",
  "block.minecraft.dead_brain_coral": "jápman vuoŋŋamuš koralla",
  "block.minecraft.dead_bubble_coral": "jápman bulljaras koralla",
  "block.minecraft.dead_fire_coral": "jápman dolla koralla",
  "block.minecraft.dead_horn_coral": "jápman čoarvvás koralla",
  "block.minecraft.dead_tube_coral": "jápman bohcci koralla",
  "block.minecraft.tube_coral_fan": "bohcci koralla fan",
  "block.minecraft.brain_coral_fan": "vuoŋŋamuš koralla fan",
  "block.minecraft.bubble_coral_fan": "bulljaras koralla fan",
  "block.minecraft.fire_coral_fan": "dolla koralla fan",
  "block.minecraft.horn_coral_fan": "čoarvvás koralla fan",
  "block.minecraft.dead_tube_coral_fan": "jápman bohcci koralla libardahtti",
  "block.minecraft.dead_brain_coral_fan": "jápman vuoŋŋamuš koralla libardahtti",
  "block.minecraft.dead_bubble_coral_fan": "jápman bulljaras koralla libardahtti",
  "block.minecraft.dead_fire_coral_fan": "jápman dolla koralla libardahtti",
  "block.minecraft.dead_horn_coral_fan": "jápman čoarvvás koralla libardahtti",
  "block.minecraft.blue_ice": "alitjiekŋa",
  "block.minecraft.conduit": "mearrameannudeaddji",
  "block.minecraft.polished_granite_stairs": "bussejuvvon granihttatráhppá",
  "block.minecraft.smooth_red_sandstone_stairs": "livttis rukses sáttogeađgetráhppá",
  "block.minecraft.mossy_stone_brick_stairs": "jeagilduvvan geađgemuvratráhppá",
  "block.minecraft.polished_diorite_stairs": "bussejuvvon diorihttatráhppá",
  "block.minecraft.mossy_cobblestone_stairs": "jeagilduvvan luoddageađgetráhppá",
  "block.minecraft.end_stone_brick_stairs": "endor geađgemuvratráhppá",
  "block.minecraft.stone_stairs": "geađgetráhppá",
  "block.minecraft.smooth_sandstone_stairs": "livttis sáttogeađgetráhppá",
  "block.minecraft.smooth_quartz_stairs": "livttis kvárcatráhppá",
  "block.minecraft.granite_stairs": "granihttatráhppá",
  "block.minecraft.andesite_stairs": "ándasihttatráhppá",
  "block.minecraft.red_nether_brick_stairs": "rukses nethermuvratráhppá",
  "block.minecraft.polished_andesite_stairs": "bussejuvvon ándasihttatráhppá",
  "block.minecraft.diorite_stairs": "diorihttatráhppá",
  "block.minecraft.polished_granite_slab": "bussejuvvon granihttapláhtta",
  "block.minecraft.smooth_red_sandstone_slab": "livttis rukses sáttogeađgepláhtta",
  "block.minecraft.mossy_stone_brick_slab": "jeagilduvvan geađgemuvrabealli",
  "block.minecraft.polished_diorite_slab": "bussejuvvon diorihttapláhtta",
  "block.minecraft.mossy_cobblestone_slab": "jeagilduvvan luoddageađgebealli",
  "block.minecraft.end_stone_brick_slab": "endorgeađgemuvrabealli",
  "block.minecraft.smooth_sandstone_slab": "livttis sáttogeađgepláhta",
  "block.minecraft.smooth_quartz_slab": "livttis kvárcapláhtta",
  "block.minecraft.granite_slab": "granihttapláhtta",
  "block.minecraft.andesite_slab": "ándasihttapláhtta",
  "block.minecraft.red_nether_brick_slab": "rukses nethermuvrabealli",
  "block.minecraft.polished_andesite_slab": "bussejuvvon ándasihttapláhtta",
  "block.minecraft.diorite_slab": "diorihttapláhtta",
  "block.minecraft.scaffolding": "luovvi",
  "block.minecraft.iron_door": "ruovdeuksa",
  "block.minecraft.oak_door": "eaikauksa",
  "block.minecraft.spruce_door": "guossauksa",
  "block.minecraft.birch_door": "soahkeuksa",
  "block.minecraft.jungle_door": "suhkkesvuvdemuorrauksa",
  "block.minecraft.acacia_door": "acaciauksa",
  "block.minecraft.dark_oak_door": "sevdnjes eaikauksa",
  "block.minecraft.crimson_door": "skárllatuksa",
  "block.minecraft.warped_door": "bonjouksa",
  "block.minecraft.repeater": "redstone geardduheaddji",
  "block.minecraft.comparator": "redstone iskkadeaddji",
  "block.minecraft.structure_block": "huskehusblohkka",
  "block.minecraft.jigsaw": "ásahanblohkka",
  "item.minecraft.turtle_helmet": "skálžogahpir□□go oaivvi alde:□+2 suojus",
  "item.minecraft.scute": "skálžu",
  "item.minecraft.iron_shovel": "ruovdegoaivu□□go váldogieđas:□+3.5 časkinvahát□-3 časkinleahttu",
  "item.minecraft.iron_pickaxe": "ruovdebiikaákšu□□go váldogieđas:□+3 časkinvahát□-2.8 časkinleahttu",
  "item.minecraft.iron_axe": "ruovdeákšu□□go váldogieđas:□+8 časkinvahát□-3.1 časkinleahttu",
  "item.minecraft.flint_and_steel": "cahkkehanruovdi",
  "item.minecraft.apple": "ebel",
  "item.minecraft.bow": "dávgi",
  "item.minecraft.arrow": "njuolla",
  "item.minecraft.coal": "koalla",
  "item.minecraft.charcoal": "čađđa",
  "item.minecraft.diamond": "diamánta",
  "item.minecraft.iron_ingot": "ruovdi",
  "item.minecraft.gold_ingot": "golli",
  "item.minecraft.netherite_ingot": "netheriita",
  "item.minecraft.netherite_scrap": "netheriitabihttážat",
  "item.minecraft.iron_sword": "ruovdemiehkki□□go váldogieđas:□+5 časkinvahát□-2.4 časkinleahttu",
  "item.minecraft.wooden_sword": "muorramiehkki□□go váldogieđas:□+3 časkinvahát□-2.4 časkinleahttu",
  "item.minecraft.wooden_shovel": "muorragoaivu□□go váldogieđas:□+1.5 časkinvahát□-3 časkinleahttu",
  "item.minecraft.wooden_pickaxe": "muorrabiikaákšu□□go váldogieđas:□+1 časkinvahát□-2.8 časkinleahttu",
  "item.minecraft.wooden_axe": "muorraákšu□□go váldogieđas:□+6 časkinvahát□-3.2 časkinleahttu",
  "item.minecraft.stone_sword": "geađgemiehkki□□go váldogieđas:□+4 časkinvahát□-2.4 časkinleahttu",
  "item.minecraft.stone_shovel": "geađgegoaivu□□go váldogieđas:□+2.5 časkinvahát□-3 časkinleahttu",
  "item.minecraft.stone_pickaxe": "geađgebiikaákšu□□go váldogieđas:□+2 časkinvahát□-2.8 časkinleahttu",
  "item.minecraft.stone_axe": "geađgeákšu□□go váldogieđas:□+8 časkinvahát□-3.2 časkinleahttu",
  "item.minecraft.diamond_sword": "diamántamiehkki□□go váldogieđas:□+6 časkinvahát□-2.4 časkinleahttu",
  "item.minecraft.diamond_shovel": "diamántagoaivu□□go váldogieđas:□+4.5 časkinvahát□-3 časkinleahttu",
  "item.minecraft.diamond_pickaxe": "diamántabiikaákšu□□go váldogieđas:□+4 časkinvahát□-2.8 časkinleahttu",
  "item.minecraft.diamond_axe": "diamántaákšu□□go váldogieđas:□+8 časkinvahát□-3 časkinleahttu",
  "item.minecraft.stick": "soabbi",
  "item.minecraft.bowl": "bollu",
  "item.minecraft.mushroom_stew": "guopparmálli",
  "item.minecraft.golden_sword": "gollemiehkki□□go váldogieđas:□+3 časkinvahát□-2.4 časkinleahttu",
  "item.minecraft.golden_shovel": "gollegoaivu□□go váldogieđas:□+1.5 časkinvahát□-3 časkinleahttu",
  "item.minecraft.golden_pickaxe": "gollebiikaákšu□□go váldogieđas:□+1 časkinvahát□-2.8 časkinleahttu",
  "item.minecraft.golden_axe": "golleákšu□□go váldogieđas:□+6 časkinvahát□-3 časkinleahttu",
  "item.minecraft.netherite_sword": "netheriitamiehkki□□go váldogieđas:□+7 časkinvahát□-2.4 časkinleahttu",
  "item.minecraft.netherite_shovel": "netheriitagoaivu□□go váldogieđas:□+5.5 časkinvahát□-3 časkinleahttu",
  "item.minecraft.netherite_pickaxe": "netheriitabiikaákšu□□go váldogieđas:□+5 časkinvahát□-2.8 časkinleahttu",
  "item.minecraft.netherite_axe": "netheriitaákšu□□go váldogieđas:□+9 časkinvahát□-3 časkinleahttu",
  "item.minecraft.string": "láigi",
  "item.minecraft.feather": "dolgi",
  "item.minecraft.gunpowder": "rukta",
  "item.minecraft.wooden_hoe": "muorraguohkki□□go váldogieđas:□-3 časkinleahttu",
  "item.minecraft.stone_hoe": "geađgeguohkki□□go váldogieđas:□-2 časkinleahttu",
  "item.minecraft.iron_hoe": "ruovdeguohkki□□go váldogieđas:□-1 časkinleahttu",
  "item.minecraft.diamond_hoe": "diamántaguohkki□□go váldogieđas:",
  "item.minecraft.golden_hoe": "golleguohkki□□go váldogieđas:□-3 časkinleahttu",
  "item.minecraft.netherite_hoe": "netheriitaguohkki□□go váldogieđas:",
  "item.minecraft.wheat_seeds": "nisogilvagat",
  "item.minecraft.wheat": "nisugordni",
  "item.minecraft.bread": "láibi",
  "item.minecraft.leather_helmet": "sistegahpir□□go oaivvi alde:□+1 suojus",
  "item.minecraft.leather_chestplate": "sistebáidi□□go goruda alde:□+3 suojus",
  "item.minecraft.leather_leggings": "sistebuvssat□□go julgiin:□+2 suojus",
  "item.minecraft.leather_boots": "sistegápmagat□□go julgiin:□+1 suojus",
  "item.minecraft.chainmail_helmet": "viđjejealbma□□go oaivvi alde:□+2 suojus",
  "item.minecraft.chainmail_chestplate": "viđjeraddepánsár□□go goruda alde:□+5 suojus",
  "item.minecraft.chainmail_leggings": "viđjebuvssat□□go julgiin:□+4 suojus",
  "item.minecraft.chainmail_boots": "viđjegápmagat□□go julgiin:□+1 suojus",
  "item.minecraft.iron_helmet": "ruovdejealbma□□go oaivvi alde:□+2 suojus",
  "item.minecraft.iron_chestplate": "ruovderaddepánsár□□go goruda alde:□+6 suojus",
  "item.minecraft.iron_leggings": "ruovdebuvssat□□go julgiin:□+5 suojus",
  "item.minecraft.iron_boots": "ruovdegápmagat□□go julgiin:□+2 suojus",
  "item.minecraft.diamond_helmet": "diamántajealbma□□go oaivvi alde:□+3 suojus□+2 sudjosa nanusvuohta",
  "item.minecraft.diamond_chestplate": "diamántaraddepánsár□□go goruda alde:□+8 suojus□+2 sudjosa nanusvuohta",
  "item.minecraft.diamond_leggings": "diamántabuvssat□□go julgiin:□+6 suojus□+2 sudjosa nanusvuohta",
  "item.minecraft.diamond_boots": "diamántagápmagat□□go julgiin:□+3 suojus□+2 sudjosa nanusvuohta",
  "item.minecraft.golden_helmet": "gollejealbma□□go oaivvi alde:□+2 suojus",
  "item.minecraft.golden_chestplate": "golleraddepánsár□□go goruda alde:□+5 suojus",
  "item.minecraft.golden_leggings": "gollebuvssat□□go julgiin:□+3 suojus",
  "item.minecraft.golden_boots": "gollegápmagat□□go julgiin:□+1 suojus",
  "item.minecraft.netherite_helmet": "netheriitajealbma□□go oaivvi alde:□+3 suojus□+3 sudjosa nanusvuohta□+1 hoigadan gierdevašvuohta",
  "item.minecraft.netherite_chestplate": "netheriitaraddepánsár□□go goruda alde:□+8 suojus□+3 sudjosa nanusvuohta□+1 hoigadan gierdevašvuohta",
  "item.minecraft.netherite_leggings": "netheriitabuvssat□□go julgiin:□+6 suojus□+3 sudjosa nanusvuohta□+1 hoigadan gierdevašvuohta",
  "item.minecraft.netherite_boots": "netheriitagapmagat□□go julgiin:□+3 suojus□+3 sudjosa nanusvuohta□+1 hoigadan gierdevašvuohta",
  "item.minecraft.flint": "didnu",
  "item.minecraft.porkchop": "njuoska spiidečoarbealli",
  "item.minecraft.cooked_porkchop": "basson spiidnečoarbealli",
  "item.minecraft.painting": "govva",
  "item.minecraft.golden_apple": "golleebel",
  "item.minecraft.enchanted_golden_apple": "noidojuvvon golleebel",
  "block.minecraft.oak_sign": "eaikagalba",
  "block.minecraft.spruce_sign": "guossagalba",
  "block.minecraft.birch_sign": "soahkegalba",
  "block.minecraft.jungle_sign": "suhkkesvuovdegalba",
  "block.minecraft.acacia_sign": "acaciagalba",
  "block.minecraft.dark_oak_sign": "sevdnjes eaikagalba",
  "block.minecraft.crimson_sign": "skárllatgalba",
  "block.minecraft.warped_sign": "bonjogalba",
  "item.minecraft.bucket": "gievdni",
  "item.minecraft.water_bucket": "čáhcegievdni",
  "item.minecraft.lava_bucket": "lavagievdni",
  "item.minecraft.minecart": "roggangielká",
  "item.minecraft.saddle": "riidensálat",
  "item.minecraft.redstone": "redstonedopmu",
  "item.minecraft.snowball": "muohtačahkir",
  "item.minecraft.oak_boat": "eaikafanas",
  "item.minecraft.leather": "sisti",
  "item.minecraft.milk_bucket": "mielkegievdni",
  "item.minecraft.pufferfish_bucket": "mirkoguolleskállu",
  "item.minecraft.salmon_bucket": "luossaskállu",
  "item.minecraft.cod_bucket": "dorskeskállu",
  "item.minecraft.tropical_fish_bucket": "trohpalašguolleskállu",
  "item.minecraft.brick": "muvrabihttá",
  "item.minecraft.clay_ball": "láiraspábba",
  "block.minecraft.dried_kelp_block": "goikoduvvon stárrablohkka",
  "item.minecraft.paper": "bábir",
  "item.minecraft.book": "girji",
  "item.minecraft.slime_ball": "njivlespábba",
  "item.minecraft.chest_minecart": "roggangielká mas bumbá",
  "item.minecraft.furnace_minecart": "roggangielká mas ovdna",
  "item.minecraft.egg": "monni",
  "item.minecraft.compass": "kompássa",
  "item.minecraft.fishing_rod": "oaggunstávrá",
  "item.minecraft.clock": "diibmu",
  "item.minecraft.glowstone_dust": "čuovgageađggedopmu",
  "item.minecraft.cod": "njuoska dorski",
  "item.minecraft.salmon": "njuoska luossa",
  "item.minecraft.tropical_fish": "trohpalaš guolli",
  "item.minecraft.pufferfish": "mirkoguolli",
  "item.minecraft.cooked_cod": "basson dorski",
  "item.minecraft.cooked_salmon": "basson luossa",
  "item.minecraft.ink_sac": "čáhppesivdnečoalli",
  "item.minecraft.red_dye": "rukses ivdni",
  "item.minecraft.green_dye": "ruoná ivdni",
  "item.minecraft.cocoa_beans": "kakáošaddu",
  "item.minecraft.lapis_lazuli": "lasura",
  "item.minecraft.purple_dye": "sáhppes ivdni",
  "item.minecraft.cyan_dye": "turkisa idvni",
  "item.minecraft.light_gray_dye": "čuovgesránes ivdni",
  "item.minecraft.gray_dye": "ránes ivdni",
  "item.minecraft.pink_dye": "čuvgesrukses ivdni",
  "item.minecraft.lime_dye": "čuvgesruoná ivdni",
  "item.minecraft.yellow_dye": "fiskes ivdni",
  "item.minecraft.light_blue_dye": "čuvgesalit ivdni",
  "item.minecraft.magenta_dye": "čuvgessáhppes ivdni",
  "item.minecraft.orange_dye": "runta ivdni",
  "item.minecraft.bone_meal": "dáktejáffu",
  "item.minecraft.blue_dye": "alit ivdni",
  "item.minecraft.brown_dye": "ruškes ivdni",
  "item.minecraft.black_dye": "čáhppes ivdni",
  "item.minecraft.white_dye": "vilges ivdni",
  "item.minecraft.bone": "dákti",
  "item.minecraft.sugar": "sohkar",
  "block.minecraft.cake": "gáhkku",
  "block.minecraft.white_bed": "vilges seaŋga",
  "block.minecraft.orange_bed": "runta seaŋga",
  "block.minecraft.magenta_bed": "čuvgessáhppes seaŋga",
  "block.minecraft.light_blue_bed": "čuvgesalit seaŋga",
  "block.minecraft.yellow_bed": "fiskes seaŋga",
  "block.minecraft.lime_bed": "čuvgesruoná seaŋga",
  "block.minecraft.pink_bed": "čuvgesrukses seaŋga",
  "block.minecraft.gray_bed": "ránes seaŋga",
  "block.minecraft.light_gray_bed": "čuovgesránes seaŋga",
  "block.minecraft.cyan_bed": "turkiisa seaŋga",
  "block.minecraft.purple_bed": "sáhppes seaŋga",
  "block.minecraft.blue_bed": "alit seaŋga",
  "block.minecraft.brown_bed": "ruškes seaŋga",
  "block.minecraft.green_bed": "ruoná seaŋga",
  "block.minecraft.red_bed": "rukses seaŋga",
  "block.minecraft.black_bed": "čáhppes seaŋga",
  "item.minecraft.cookie": "keaksa",
  "item.minecraft.filled_map": "kárta□#0",
  "item.minecraft.shears": "skárret",
  "item.minecraft.melon_slice": "meluvdna bihttá",
  "item.minecraft.dried_kelp": "goikaduvvon stárra",
  "item.minecraft.pumpkin_seeds": "murbbetgilvagat",
  "item.minecraft.melon_seeds": "meluvdnagilvagat",
  "item.minecraft.beef": "njuoska gusabiergu",
  "item.minecraft.cooked_beef": "steaika",
  "item.minecraft.chicken": "njuoska vuoncábiergu",
  "item.minecraft.cooked_chicken": "basson vuoncábiergu",
  "item.minecraft.rotten_flesh": "guohcagan biergu",
  "item.minecraft.ender_pearl": "endorhelbmo",
  "item.minecraft.blaze_rod": "buollistálu sággi",
  "item.minecraft.ghast_tear": "gopmi gaŋaldat",
  "item.minecraft.gold_nugget": "gollebihttáš",
  "item.minecraft.nether_wart": "nether spártu",
  "item.minecraft.potion": "duojatkas jugus□ii leat váikkuhuvvon",
  "item.minecraft.glass_bottle": "lásebohtal",
  "item.minecraft.spider_eye": "heavdnečalbmi",
  "item.minecraft.fermented_spider_eye": "fermenterejuvvon heavdnečalbmi",
  "item.minecraft.blaze_powder": "buollistálu bulvvar",
  "item.minecraft.magma_cream": "magmakreamma",
  "block.minecraft.brewing_stand": "vuoššahat",
  "block.minecraft.cauldron": "ruitu",
  "item.minecraft.ender_eye": "endorčalbmi",
  "item.minecraft.glistering_melon_slice": "šelges meluvdnabihttáš",
  "item.minecraft.bat_spawn_egg": "girdisáhpána ealáskanmonni",
  "item.minecraft.bee_spawn_egg": "uvllu ealáskanmonni",
  "item.minecraft.blaze_spawn_egg": "buollistálu ealáskanmonni",
  "item.minecraft.cat_spawn_egg": "bussá ealáskanmonni",
  "item.minecraft.cave_spider_spawn_egg": "hoalluheavnni ealáskanmonni",
  "item.minecraft.chicken_spawn_egg": "vuoncá ealáskanmonni",
  "item.minecraft.cod_spawn_egg": "dorski ealáskanmonni",
  "item.minecraft.cow_spawn_egg": "gusa ealáskanmonni",
  "item.minecraft.creeper_spawn_egg": "creepera ealáskanmonni",
  "item.minecraft.dolphin_spawn_egg": "delfiinna ealáskanmonni",
  "item.minecraft.donkey_spawn_egg": "ása ealáskanmonni",
  "item.minecraft.drowned_spawn_egg": "heavvanan ealáskanmonni",
  "item.minecraft.elder_guardian_spawn_egg": "dološ várjaleaddji ealáskanmonni",
  "item.minecraft.enderman_spawn_egg": "endorolbmo ealáskanmonni",
  "item.minecraft.endermite_spawn_egg": "endorsáhpána ealáskanmonni",
  "item.minecraft.evoker_spawn_egg": "gonstošeaddji ealáskanmonni",
  "item.minecraft.fox_spawn_egg": "riebana ealáskanmonni",
  "item.minecraft.ghast_spawn_egg": "gopmi ealáskanmonni",
  "item.minecraft.guardian_spawn_egg": "várjaleaddji ealáskanmonni",
  "item.minecraft.hoglin_spawn_egg": "hoglina ealáskanmonni",
  "item.minecraft.horse_spawn_egg": "heasta ealáskanmonni",
  "item.minecraft.husk_spawn_egg": "goikejámeža ealáskanmonni",
  "item.minecraft.llama_spawn_egg": "llama ealáskanmonni",
  "item.minecraft.magma_cube_spawn_egg": "magmaealli ealáskanmonni",
  "item.minecraft.mooshroom_spawn_egg": "mooshrooma ealáskanmonni",
  "item.minecraft.mule_spawn_egg": "muvlla ealáskanmonni",
  "item.minecraft.ocelot_spawn_egg": "meahccebussá ealáskanmonni",
  "item.minecraft.panda_spawn_egg": "panda ealáskanmonni",
  "item.minecraft.parrot_spawn_egg": "papegoia ealáskanmonni",
  "item.minecraft.phantom_spawn_egg": "idjagopmi ealáskanmonni",
  "item.minecraft.pig_spawn_egg": "spiinni ealáskanmonni",
  "item.minecraft.piglin_spawn_egg": "piglina ealáskanmonni",
  "item.minecraft.pillager_spawn_egg": "rievvára ealáskanmonni",
  "item.minecraft.polar_bear_spawn_egg": "jiekŋaguovžža ealáskanmonni",
  "item.minecraft.pufferfish_spawn_egg": "mirkoguoli ealáskanmonni",
  "item.minecraft.rabbit_spawn_egg": "njoammila ealáskanmonni",
  "item.minecraft.ravager_spawn_egg": "mollenstálu ealáskanmonni",
  "item.minecraft.salmon_spawn_egg": "luosa ealáskanmonni",
  "item.minecraft.sheep_spawn_egg": "sávzza ealáskanmonni",
  "item.minecraft.shulker_spawn_egg": "shulkera ealáskanmonni",
  "item.minecraft.silverfish_spawn_egg": "silbasáhpána ealáskanmonni",
  "item.minecraft.skeleton_spawn_egg": "dákterikki ealáskanmonni",
  "item.minecraft.skeleton_horse_spawn_egg": "dákteriggeheasta ealáskanmonni",
  "item.minecraft.slime_spawn_egg": "njivleealli ealáskanmonni",
  "item.minecraft.spider_spawn_egg": "heavnni ealáskanmonni",
  "item.minecraft.squid_spawn_egg": "áhkárguoli ealáskanmonni",
  "item.minecraft.stray_spawn_egg": "vádjoleaddji ealáskanmonni",
  "item.minecraft.strider_spawn_egg": "gálašeaddji ealáskanmonni",
  "item.minecraft.trader_llama_spawn_egg": "vuovdaleaddji llama ealáskanmonni",
  "item.minecraft.tropical_fish_spawn_egg": "trohpalaš guoli ealáskanmonni",
  "item.minecraft.turtle_spawn_egg": "galbarihcci ealáskanmonni",
  "item.minecraft.vex_spawn_egg": "biidnogopmi ealáskanmonni",
  "item.minecraft.villager_spawn_egg": "gillilačča ealáskanmonni",
  "item.minecraft.vindicator_spawn_egg": "vávtta ealáskanmonni",
  "item.minecraft.wandering_trader_spawn_egg": "johttigávppašeaddji ealáskanmonni",
  "item.minecraft.witch_spawn_egg": "noaiddi ealáskanmonni",
  "item.minecraft.wither_skeleton_spawn_egg": "witherdákterikki ealáskanmonni",
  "item.minecraft.wolf_spawn_egg": "gumpe ealáskanmonni",
  "item.minecraft.zoglin_spawn_egg": "zoglina ealáskanmonni",
  "item.minecraft.zombie_spawn_egg": "jámeža ealáskanmonni",
  "item.minecraft.zombie_horse_spawn_egg": "jámešheasta ealáskanmonni",
  "item.minecraft.zombie_villager_spawn_egg": "jámeš gillilačča ealáskanmonni",
  "item.minecraft.zombified_piglin_spawn_egg": "piglinjábmi ealáskanmonni",
  "item.minecraft.experience_bottle": "noaidobohtal",
  "item.minecraft.fire_charge": "buolligeađgi",
  "item.minecraft.writable_book": "girji ja čállindolgi",
  "item.minecraft.written_book": "čállon girji",
  "item.minecraft.emerald": "emerálda",
  "item.minecraft.item_frame": "dávvirrámma",
  "block.minecraft.flower_pot": "lieđđeruhkku",
  "item.minecraft.carrot": "rušpi",
  "item.minecraft.potato": "buđet",
  "item.minecraft.baked_potato": "liggejuvvon buđet",
  "item.minecraft.poisonous_potato": "mirkkolaš buđet",
  "item.minecraft.map": "guoros kárta",
  "item.minecraft.golden_carrot": "gollerušpi",
  "block.minecraft.skeleton_skull": "dákterikki oaiveskálžu",
  "block.minecraft.wither_skeleton_skull": "wither dákterikki oaiveskálžu",
  "block.minecraft.player_head": "spealleoaivi",
  "block.minecraft.zombie_head": "jámeža oaivi",
  "block.minecraft.creeper_head": "creeper oaivi",
  "block.minecraft.dragon_head": "drága oaivi",
  "item.minecraft.carrot_on_a_stick": "rušpi oaggunstávrras",
  "item.minecraft.warped_fungus_on_a_stick": "bonjoguoppar stággus",
  "item.minecraft.nether_star": "nether násti",
  "item.minecraft.pumpkin_pie": "gurbbet paia",
  "item.minecraft.firework_rocket": "rakeahtta",
  "item.minecraft.firework_star": "rahkeahttanásti",
  "item.minecraft.enchanted_book": "noidojuvvon girji",
  "item.minecraft.nether_brick": "nethermuvra",
  "item.minecraft.quartz": "netherkvártsa",
  "item.minecraft.tnt_minecart": "roggangielká mas tnt",
  "item.minecraft.hopper_minecart": "roggangielká mas njammi",
  "item.minecraft.prismarine_shard": "prismariidnamoallu",
  "item.minecraft.prismarine_crystals": "prismariidnakristálla",
  "item.minecraft.rabbit": "njuoska njoammelbiergu",
  "item.minecraft.cooked_rabbit": "basson njoammelbiergu",
  "item.minecraft.rabbit_stew": "njoammelmálli",
  "item.minecraft.rabbit_foot": "njoammeljuolgi",
  "item.minecraft.rabbit_hide": "njoammelduolji",
  "item.minecraft.armor_stand": "suodjalus čajeheaddji",
  "item.minecraft.iron_horse_armor": "heasta ruovdesudjalus",
  "item.minecraft.golden_horse_armor": "heasta gollesudjalus",
  "item.minecraft.diamond_horse_armor": "heasta diamántasuodjalus",
  "item.minecraft.leather_horse_armor": "heasta náhkkesudjalus",
  "item.minecraft.lead": "lávži",
  "item.minecraft.name_tag": "nammamearka",
  "item.minecraft.command_block_minecart": "roggangielká mas kommándoblohkka",
  "item.minecraft.mutton": "njuoska lábbabiergu",
  "item.minecraft.cooked_mutton": "basson lábbabiergu",
  "block.minecraft.white_banner": "vilges leavga",
  "block.minecraft.orange_banner": "runta leavga",
  "block.minecraft.magenta_banner": "čuvgessáhppes leavga",
  "block.minecraft.light_blue_banner": "čuvgesalit leavga",
  "block.minecraft.yellow_banner": "fiskkes leavga",
  "block.minecraft.lime_banner": "čuvgesruoná leavga",
  "block.minecraft.pink_banner": "čuvgesrukses leavga",
  "block.minecraft.gray_banner": "ránes leavga",
  "block.minecraft.light_gray_banner": "čuovgesránes leavga",
  "block.minecraft.cyan_banner": "turkiisa leavga",
  "block.minecraft.purple_banner": "sáhppes leavga",
  "block.minecraft.blue_banner": "alit leavga",
  "block.minecraft.brown_banner": "ruškes leavga",
  "block.minecraft.green_banner": "ruoná leavga",
  "block.minecraft.red_banner": "rukses leavga",
  "block.minecraft.black_banner": "čáhppes leavga",
  "item.minecraft.end_crystal": "endorkristálla",
  "item.minecraft.chorus_fruit": "chorusšattus",
  "item.minecraft.popped_chorus_fruit": "rahpasan chorusšattus",
  "item.minecraft.beetroot": "ruksesruohtas",
  "item.minecraft.beetroot_seeds": "ruksesruohtassiepmanat",
  "item.minecraft.beetroot_soup": "ruksesruohtasmálli",
  "item.minecraft.dragon_breath": "drágavuoiŋŋastat",
  "item.minecraft.splash_potion": "duojakas diškalanjugus□ii leat váikkuhuvvon",
  "item.minecraft.spectral_arrow": "suotnjar njuolla",
  "item.minecraft.tipped_arrow": "duojatkas budnjonnjuolla□ii leat váikkuhuvvon",
  "item.minecraft.lingering_potion": "bissovaš duojatkas jugus□ii leat váikkuhuvvon",
  "item.minecraft.shield": "galba",
  "item.minecraft.elytra": "soajit",
  "item.minecraft.spruce_boat": "guossafanas",
  "item.minecraft.birch_boat": "soahkefanas",
  "item.minecraft.jungle_boat": "suhkesvuovdefanas",
  "item.minecraft.acacia_boat": "acaciafanas",
  "item.minecraft.dark_oak_boat": "sevdnjes eaikafanas",
  "item.minecraft.totem_of_undying": "jápmemeahttunvuođa árdna",
  "item.minecraft.shulker_shell": "shulker skálžu",
  "item.minecraft.iron_nugget": "ruovdebihttáš",
  "item.minecraft.knowledge_book": "máhttogirji",
  "item.minecraft.debug_stick": "sivvaohcansággi",
  "item.minecraft.music_disc_13": "musihkkaskearru□c418 - 13",
  "item.minecraft.music_disc_cat": "musihkkaskearru□c418 - cat",
  "item.minecraft.music_disc_blocks": "musihkkaskearru□c418 - blocks",
  "item.minecraft.music_disc_chirp": "musihkkaskearru□c418 - chirp",
  "item.minecraft.music_disc_far": "musihkkaskearru□c418 - far",
  "item.minecraft.music_disc_mall": "musihkkaskearru□c418 - mall",
  "item.minecraft.music_disc_mellohi": "musihkkaskearru□c418 - mellohi",
  "item.minecraft.music_disc_stal": "musihkkaskearru□c418 - stal",
  "item.minecraft.music_disc_strad": "musihkkaskearru□c418 - strad",
  "item.minecraft.music_disc_ward": "musihkkaskearru□c418 - ward",
  "item.minecraft.music_disc_11": "musihkkaskearru□c418 - 11",
  "item.minecraft.music_disc_wait": "musihkkaskearru□c418 - wait",
  "item.minecraft.music_disc_pigstep": "musihkkaskearru□lena raine - pigstep",
  "item.minecraft.trident": "háŋgu□□go váldogieđas:□+8 časkinvahát□-2.9 časkinleahttu",
  "item.minecraft.phantom_membrane": "idjagopmi cuozza",
  "item.minecraft.nautilus_shell": "nautilus skálžu",
  "item.minecraft.heart_of_the_sea": "mearaváibmu",
  "item.minecraft.crossbow": "dávgebissu",
  "item.minecraft.suspicious_stew": "imašlagan málli",
  "block.minecraft.loom": "gákkesmuorat",
  "item.minecraft.flower_banner_pattern": "leavga minsttár□lieđđeminsttar",
  "item.minecraft.creeper_banner_pattern": "leavga minsttár□creeperminsttar",
  "item.minecraft.skull_banner_pattern": "leavga minsttár□oaiveskálžominsttar",
  "item.minecraft.mojang_banner_pattern": "leavga minsttár□mojangminsttar",
  "item.minecraft.globe_banner_pattern": "leavga minsttár□máilmmeminsttar",
  "item.minecraft.piglin_banner_pattern": "leavga minsttár□njunni",
  "block.minecraft.composter": "kompostár",
  "block.minecraft.barrel": "fárppal",
  "block.minecraft.smoker": "suovastanuvdna",
  "block.minecraft.blast_furnace": "goardinovdna",
  "block.minecraft.cartography_table": "kártenbeavdi",
  "block.minecraft.fletching_table": "njuollabeavdi",
  "block.minecraft.grindstone": "heidnengeađgi",
  "block.minecraft.lectern": "sárdnestuollu",
  "block.minecraft.smithing_table": "rávdenbeavdi",
  "block.minecraft.stonecutter": "geađgečuohppi",
  "block.minecraft.bell": "biellu",
  "block.minecraft.lantern": "likta",
  "block.minecraft.soul_lantern": "siello likta",
  "item.minecraft.sweet_berries": "váramat",
  "block.minecraft.campfire": "dollagáddi",
  "block.minecraft.soul_campfire": "siellodollagáddi",
  "block.minecraft.shroomlight": "guopparčuovga",
  "item.minecraft.honeycomb": "honnetbihttá",
  "block.minecraft.bee_nest": "uvlubeassi",
  "block.minecraft.beehive": "uvluviessu",
  "item.minecraft.honey_bottle": "honnetbohtal",
  "block.minecraft.honey_block": "honnetblohkka",
  "block.minecraft.honeycomb_block": "honnetbihttáblohkka",
  "block.minecraft.lodestone": "láidengeađgi",
  "block.minecraft.netherite_block": "netheriitablohkka",
  "block.minecraft.ancient_debris": "dološ bázahusat",
  "block.minecraft.target": "deaivvus",
  "block.minecraft.crying_obsidian": "čierru garrageađgi",
  "block.minecraft.blackstone": "čáhppesgeađgi",
  "block.minecraft.blackstone_slab": "čáhppesgeađgepláhtta",
  "block.minecraft.blackstone_stairs": "čáhppesgeađgetráhppá",
  "block.minecraft.gilded_blackstone": "gollás čáhppesgeađgi",
  "block.minecraft.polished_blackstone": "bussejuvvon čáhppesgeađgi",
  "block.minecraft.polished_blackstone_slab": "bussejuvvon čáhppesgeađgepláhtta",
  "block.minecraft.polished_blackstone_stairs": "bussejuvvon čáhppesgeađgetráhppá",
  "block.minecraft.chiseled_polished_blackstone": "lukčon bussejuvvon čáhppesgeađgi",
  "block.minecraft.polished_blackstone_bricks": "bussejuvvon čáhppesgeađgemuvra",
  "block.minecraft.polished_blackstone_brick_slab": "bussejuvvon čáhppesgeađgemuvrapláhtta",
  "block.minecraft.polished_blackstone_brick_stairs": "bussejuvvon čáhppesgeađgemuvratráhppá",
  "block.minecraft.cracked_polished_blackstone_bricks": "luoddanan bussejuvvon čáhppesgeađgemuvra",
  "block.minecraft.respawn_anchor": "ealáskanáŋkor",
}
export const se_no = items; 
